<div class="createSuggestedCoachingModal w-100 h-100 position-relative">
    <!-- Close button -->
    <div class="position-absolute" style="top: 8px; right: -8px;">
        <button type="button" class="icon-btn fill-valyrianSteel fill-hover-whaleTail" (click)="close()">
            <svg class="icon-16">
                <use href="../../App_Themes/clearview-default/icons/utility/close.svg#close"></use>
            </svg>
        </button>
    </div>
    <!-- Main Modal Content -->
    <div class="suggestcoaching-content w-100 h-100" *ngIf="!isLoading">
        <div class="d-flex flex-column">
            <!-- Heading -->
            <div>
                <!-- Title -->
                <div class="mt-3 mb-2 border-separator pb-2">
                    <h6 class="font-size-20 m-0" cvLocalizedText langSection="Coaching" langKey="SuggestModal_Title">
                        Suggest Coaching Session
                    </h6>
                    <div class="body-2 mt-1">{{supportData.GroupName}}</div>
                </div>
                <div class="border-separator d-flex flex-column pl-1" style="overflow-y: auto; max-height: 70vh;">
                    <!-- User input items -->
                    <!-- Reason -->
                    <div class="mb-2">
                        <label class="d-block mb-0">
                            <span class="font-size-12" cvLocalizedText langSection="Coaching" langKey="SuggestModal_Form_Reason_Label">Reason for Coaching</span>
                            <input class="form-control form-control-lg mt-1" type="text" [(ngModel)]="formData.reason" (ngModelChange)="checkValidForm()"
                                   cvLocalizedText langSection="Coaching" langKey="SuggestModal_Form_Reason_Placeholder" />
                        </label>
                    </div>
                    <!-- Coaching Form -->
                    <div class="mb-2">
                        <label class="d-block mb-0">
                            <span class="font-size-12" cvLocalizedText langSection="Coaching" langKey="SuggestModal_Form_Select_Form_Label">Select Coaching Form</span>
                            <select class="form-control form-control-lg mt-1" placeholder="Coaching Forms" [(ngModel)]="formData.formID">
                                <option value="0" cvLocalizedText langSection="Coaching" langKey="None">None</option>
                                <option *ngFor="let form of supportData.CoachingForms" [ngValue]="form.FormID">{{form.FormName}}</option>
                            </select>
                        </label>
                    </div>
                    <!-- Start By -->
                    <div class="mb-2">
                        <label class="d-block mb-0 w-75">
                            <span class="font-size-12" cvLocalizedText langSection="Coaching" langKey="SuggestModal_Form_StartBy_Label">Start Suggested Coaching Session by</span>
                        </label>
                        <div class="input-group mt-1 d-flex">
                            <div class="input-group-btn">
                                <cv-baremetrics-calendar class="d-block daterange daterange--single pr-3"
                                                            [(currentDate)]="selectedDate"
                                                            [earliestDate]="initialStartByTime"
                                                            [required]="false"
                                                            [placeholder]="'00/00/0000'"
                                                            (dateChanged)="onDateChange($event)"></cv-baremetrics-calendar>
                            </div>
                            <div class="input-group-btn">                                    
                                <cv-time-picker [(ngModel)]="formData.startByDate"
                                                style="background-image:none"></cv-time-picker>
                            </div>
                        </div>
                    </div>
                    <!-- Assign To -->
                    <div class="mb-2">
                        <label class="d-block mb-2 w-75">
                            <span class="font-size-12" cvLocalizedText langSection="Coaching" langKey="Assignment_Type">Assignment Type</span>
                            <select class="form-control mt-1" (ngModelChange)="onAssignTypeChanged($event)" [(ngModel)]="selectedAssignType">
                                <option *ngFor="let type of assignmentTypes | keyvalue" [ngValue]="type.value">{{type.key}}</option>
                            </select>
                        </label>
                        <label class="d-block mb-2 w-75" *ngIf="selectedAssignType === 1">
                            <span class="font-size-12" cvLocalizedText langSection="Users" langKey="Level_Title">Level</span>
                            <select class="form-control mt-1" [(ngModel)]="selectedGroupLevel" (ngModelChange)="onGroupLevelChanged()">
                                <option *ngFor="let level of supportData.GroupLevels" [ngValue]="level">{{level.LevelName}}</option>
                            </select>
                        </label>
                        <label class="d-block w-75" *ngIf="selectedAssignType === 1">
                            <span class="font-size-12" cvLocalizedText langSection="Users" langKey="Role_Title">Role</span>
                            <select class="form-control mt-1" [(ngModel)]="formData.roleID" (ngModelChange)="checkValidForm()">
                                <option *ngFor="let role of supportData.Roles" [ngValue]="role.RoleID">{{role.RoleName}}</option>
                            </select> 
                        </label>
                        <div class="d-flex flex-column w-75" *ngIf="selectedAssignType === 2">
                            <span class="font-size-12" cvLocalizedText langSection="Controls" langKey="User">User</span>
                            <cv-multi-select class="multiSelectLeft"
                                             [options]="supportData.Users"
                                             [value]="selectedUserList"
                                             (valueChange)="onUserChanged($event)"
                                             [placeholder]="getLocalizedString('None')"
                                             primaryKey="LoginID" label="LoginName"></cv-multi-select>
                        </div>
                    </div>
                    <!-- Notes -->
                    <div class="d-flex align-items-center pb-2 pt-2">
                        <input type="checkbox" id="includeNote" [(ngModel)]="formData.hasNotes"/>
                        <label class="form-check-label font-size-12 pl-2" for="includeNote" cvLocalizedText langSection="Coaching" langKey="Include_Note">Include a note</label>
                    </div>
                    <div class="FlexColNoWrap coachingPopupNotesMain mb-2" *ngIf="formData.hasNotes">
                        <div class="d-flex flex-nowrap font-size-12">
                            <span cvLocalizedText langSection="Coaching" langKey="Added_Note">Added Note</span>
                            <div class="d-inline ml-2">
                                <div class="d-inline" #hyperlinkPopover="ngbPopover" [ngbPopover]="hyperlinkContent" [autoClose]="'outside'" placement="right">
                                    <svg class="icon-16 fill-theUpsideDown clickable" placement="top" ngbTooltip="{{hyperlinkTooltipTxt}}">
                                        <use href="../App_Themes/clearview-default/icons/utility/link.svg#link"></use>
                                    </svg>
                                </div>
                                <!-- Hyperlink Popover -->
                                <ng-template #hyperlinkContent>
                                    <div class="font-size-10 color-whaleTail" style="width: 184px; height: 122px;">
                                        <div class="w-100 mt-1">
                                            <div class="pb-2">
                                                <span class="lato-bold" cvLocalizedText langSection="Coaching" langKey="Display_Text">Display Text</span>
                                                <span class="pl-1" placement="top" ngbTooltip="{{specialCharTooltipTxt}}">
                                                    <svg class="fill-whaleTail" style="height:12px; width:12px;">
                                                        <use href="../App_Themes/clearview-default/icons/utility/support.svg#support"></use>
                                                    </svg>
                                                </span>
                                            </div>
                                            <input type="text" class="form-control mb-2 pl-1 font-size-12" style="height:20px;" 
                                                   [(ngModel)]="linkDisplayTxtTemp" (ngModelChange)="validateDisplayText()"/>
                                            <div class="pb-2">
                                                <span class="lato-bold" cvLocalizedText langSection="Coaching" langKey="Url_Link">URL Link</span>
                                            </div>
                                            <input type="text" class="form-control coachingUrlInput font-size-12 pl-1" style="height:20px;"
                                                   [(ngModel)]="hyperlinkAddressTemp" (ngModelChange)="validateHyperlinkAddress()"
                                                   cvLocalizedPlaceholder langSection="Coaching" langKey="Example_Url"/>
                                        </div>
                                        <div class="d-flex justify-content-end mt-2">
                                            <button type="button" class="btn-text-gray" cvLocalizedText langSection="Common" langKey="Cancel_Button" (click)="closeHyperlinkPopup()">
                                                Cancel
                                            </button>
                                            <button type="button" class="btn-text coachingPrimaryButton" 
                                                    cvLocalizedText langSection="Coaching" langKey="Add_Link"
                                                    (click)="addHyperlink(hyperlinkAddressTemp)"
                                                    [disabled]="!validURL || !validDisplayText || !linkDisplayTxtTemp">
                                                Add Link
                                            </button>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                        <div contenteditable="true" style="border: 1px solid #ccc; height: 100px; overflow: auto;" id="notesTextArea" 
                             class="coachingNotesLinks pl-2 rounded"
                             (keyup)="handleKeyupEvent($event)" (click)="updateCursorPosition()" (paste)="handlePasteEvent($event)"
                             (copy)="copyToClipboard($event)" (cut)="copyToClipboard($event)" (input)="onInputChange($event)">
                        </div>
                    </div>
                </div>
                <!-- Modal Buttons -->
                <div class="buttons-holder d-flex justify-content-end">
                    <button type="button" class="btn btn-text mr-2" (click)="onCancel()" cvLocalizedText langSection="Common" langKey="Cancel_Button">
                        Cancel
                    </button>
                    <button type="button" class="btn btn-primary" [disabled]="!readyToSubmit" (click)="onCreate()"
                            cvLocalizedText langSection="Common" langKey="Apply">
                        Apply
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
